import { getAnalytics } from "@tm/insurance/analytics";
import { trackEvent } from "@tm/insurance/analytics/xdm";
import { navigationActions } from "@tm/insurance/navigation";
import { formatDate, getCookieByName } from "@tm/insurance/utils";
import { DATE_FORMATS, PARTNER } from "@tm/isomorphic-utils";
import {
  AnchorTag,
  FlexComp,
  H5Tag,
  ImageComponent,
  ParaTag,
  SpanTag,
} from "@tm/static";
import { usePartnerContext } from "@tm/static/partnerContext";
import { usePlanType } from "@tm/ui";
import { useBreakpointV2 } from "@tm/ui-widgets";
import { storePageTransitionStart } from "@tm/utility/analytics";
import { theme } from "@tm/utility/global";
import CountryFormatter from "../CountryFormatter";
import FormattedText from "../FormattedText/FormattedText";
import {
  ListingEditDetailsStyle,
  ListingSpan,
} from "./ListingEditDetails.style";

const analytics = getAnalytics();
interface ListingEditDetailsProps {
  mode?: string | null;
  title?: string | null;
  travelPurpose?: string | null;
  travelDates?: {
    startDate?: Date;
    endDate?: Date;
  };
  travellerCount?: number;
  showEditIcon: boolean;
}

const ListingEditDetails = ({
  mode,
  title,
  travelPurpose,
  travelDates,
  travellerCount,
  showEditIcon,
}: ListingEditDetailsProps) => {
  const device = useBreakpointV2();
  const { startDate, endDate } = travelDates || {};
  const { type } = usePlanType();
  const context = usePartnerContext();
  const handleEditClick = () => {
    analytics?.trackListingEvents(
      { actionType: "edit_clicked" },
      "pageView",
      type
    );
    trackEvent({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "edit_clicked",
      },
    });
    const queryParams = new URLSearchParams(window.location.search);
    const params = {
      countries: queryParams.get("countries"),
      startDate: queryParams.get("startDate"),
      endDate: queryParams.get("endDate"),
      travellers: queryParams.get("travellers"),
      segment: queryParams.get("segment"),
      type: queryParams.get("type") || "",
      tripOption: queryParams.get("tripOption") || "",
      planType: queryParams.get("planType") || "",
    };
    if (
      getCookieByName("isCommonLanding") === "true" &&
      !queryParams.get("type")
    ) {
      storePageTransitionStart("listing");
      navigationActions.navigateToCommonLanding(params);
      // const HOSTNAME = window.location.hostname;
      // navigationActions.navigateToRouteNameWithHostname(
      //   ROUTE_CONSTANTS.COMMON_LANDING,
      //   params
      // );
      //TODO: aDD This once we have the common landing page for seo
    } else {
      navigationActions.navigateToLanding(params, false);
    }
  };
  //TODO: Remove conditional icons logic everywhere for myBiz and use css var + data-theme for it
  return (
    <ListingEditDetailsStyle>
      <FlexComp
        alignItems="enter"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        {device == "lg" ? (
          <H5Tag color={theme.blackText}>
            {title && <CountryFormatter title={title} />}
          </H5Tag>
        ) : (
          <ParaTag fontSize="md" fontWeight="black" color={theme.blackText}>
            {title && <CountryFormatter title={title} />}
          </ParaTag>
        )}
        {showEditIcon && (
          <AnchorTag handleClick={handleEditClick}>
            <ImageComponent
              width="25px"
              height="25px"
              src={
                context === PARTNER.MYBIZ
                  ? "https://tripmoneycmsimgak.mmtcdn.com/img/Icon_Group_356e8bd372.png"
                  : "https://tripmoneycmsimgak.mmtcdn.com/img/edit_Icon_be6c24806a.svg"
              }
            />
          </AnchorTag>
        )}
      </FlexComp>
      <FlexComp>
        {mode && (
          <ListingSpan color={theme.blackText}>
            <SpanTag fontSize="md" color={theme.blackText}>
              <FormattedText value={mode} />
            </SpanTag>
          </ListingSpan>
        )}
        {startDate && endDate && (
          <ListingSpan color={theme.blackText}>
            <SpanTag color={theme.blackText} fontSize="md" fontWeight="black">
              {formatDate(startDate, DATE_FORMATS["D MMM"])}'
            </SpanTag>
            {formatDate(startDate, DATE_FORMATS.YY)} -To-{" "}
            <SpanTag color={theme.blackText} fontSize="md" fontWeight="black">
              {formatDate(endDate, DATE_FORMATS["D MMM"])}'
            </SpanTag>
            {formatDate(endDate, DATE_FORMATS.YY)}
          </ListingSpan>
        )}
        {travellerCount && travellerCount > 0 ? (
          <ListingSpan color={theme.blackText}>
            <SpanTag color={theme.blackText} fontSize="md" fontWeight="bold">
              {travellerCount}&nbsp;
            </SpanTag>
            <SpanTag color={theme.blackText} fontSize="md">
              {travellerCount > 1 ? "Travellers" : "Traveller"}
            </SpanTag>
          </ListingSpan>
        ) : null}

        {/* {travelPurpose && (
                    <ListingSpan
                        color={theme.blackText}
                        dangerouslySetInnerHTML={{ __html: travelPurpose }}
                    />
                )} */}
      </FlexComp>
    </ListingEditDetailsStyle>
  );
};

export default ListingEditDetails;
